{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://www.w3.org/ns/pub-schema/manifest/module/localizable-object.schema.json",
  "title": "Localizable String Object",
  "type": "object",
  "properties": {
    "value": {
      "type": "string"
    },
    "language": {
      "$ref": "bcp.schema.json"
    }
  },
  "required": ["value"]
}
